import React, { useEffect, useState, Fragment } from "react";
import Modal from "@material-ui/core/Modal";
import { Button } from "reactstrap";
import ListNotificationsType from "./ListNotificationsType";
import ListNotificationsTypeActions from "./ListNotificationsTypeActions";

const NotificationsUserConfig = ({
  data,
  openModalNotificationUserConfig,
  closeModalNotificationUserConfig,
  listTypesNotification,
  dataUser,
}) => {  
  const [dataNotifications, setDataNotifications] = useState([]);

  useEffect(() => {
    getConfigurationNotificationUser();
  }, []);

  const getConfigurationNotificationUser = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "notificacion-configuracion/listar?id_usuario=" +
        dataUser.id_usuario,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setDataNotifications(data);
      })
      .catch((error) => {
        console.error("Error:", error);
        setDataNotifications([]);
      });
  };

  return (
    <Fragment>
      <Modal
        open={openModalNotificationUserConfig}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{ zIndex: 1000 }}
      >
        <div
          className="paperAppointment-flex"
          style={{ width: "100%", margin: 5 }}
        >
          <div className="subtitle-mod" style={{ marginBottom: "8px" }}>
            <h4>Configuración de Notificaciones</h4>
          </div>
          <br />
          <div>
            <ListNotificationsType
              reactTableData={listTypesNotification}
              ReactTableActions={ListNotificationsTypeActions}
              dataUser={dataUser}
              dataNotifications={dataNotifications}
              getConfigurationNotificationUser={
                getConfigurationNotificationUser
              }
            />
          </div>
          <br />
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              style={{ marginTop: 10, marginLeft: 15 }}
              variant="contained"
              onClick={() => {
                closeModalNotificationUserConfig(false);
              }}
            >
              Cerrar
            </Button>
          </div>
        </div>
      </Modal>
    </Fragment>
  );
};

export default NotificationsUserConfig;
